import { Card, CardContent, Grid } from "@mui/material";
import { FunctionField, Labeled, SimpleShowLayout, TextField } from "react-admin";
import { IdType } from "utils/constants";
import StudentAvatar from "../StudentAvatar";
import { SectionTitle } from "features/SectionTitle";

const StudentRecordDetails = ({ studentRecordDetails, studentName }) => {
  if (!studentRecordDetails) return null;

  return (
    <>
      {studentRecordDetails && <StudentAvatar educationId={studentRecordDetails?.studentEducationId} />}
      <SectionTitle
        title="Детайли студентски картон"
        textAlign="center"
        sx={{ mt: 2, mb: 1 }}
      />
      {studentRecordDetails && (
        <SimpleShowLayout record={studentRecordDetails}>
          <Card
            key={studentRecordDetails?.studentId}
            sx={{ mb: 2, pt: 1, pl: 2 }}
          >
            <CardContent>
              <Grid
                spacing={2}
                container
              >
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <Labeled label="Име">
                    <FunctionField render={() => studentName} />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <Labeled label="Факултетен номер">
                    <TextField source="facultyNumber" />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <Labeled
                    label={
                      studentRecordDetails?.personIdType === IdType.EGN
                        ? "ЕГН"
                        : studentRecordDetails?.personIdType === IdType.PNF
                          ? "ЛНЧ"
                          : "ПИД"
                    }
                  >
                    <TextField source="personId" />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <Labeled label="Пол">
                    <TextField source="genderText" />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <Labeled label="Специалност">
                    <TextField source="speciality" />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <Labeled label="Курс">
                    <TextField source="courseText" />
                  </Labeled>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </SimpleShowLayout>
      )}
    </>
  );
};

export default StudentRecordDetails;
